import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    REVIEW_TYPE_OF_PROVIDER,
    REVIEW_TYPE_OF_CUSTOMER,
    propTypes,
} from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    createResourceLocatorString,
} from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import {
    getMarketplaceEntities,
    getListingsById,
} from '../../ducks/marketplaceData.duck';
import {
    Page,
    LayoutSideNavigation,
    LayoutWrapperMain,
    LayoutWrapperSideNav,
    LayoutWrapperTopbar,
    LayoutWrapperFooter,
    Footer,
    AvatarLarge,
    NamedLink,
    Reviews,
    ButtonTabNavHorizontal,
    ListingCard,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import config from '../../config';

import css from './ProfilePage.module.css';
import { findOptionsForSelectFilter } from '../../util/search';
import {
    getAllAvailableListing,
    getFavoriteListings,
} from './ProfilePage.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

const MAX_MOBILE_SCREEN_WIDTH = 768;

export class ProfilePageComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // keep track of which reviews tab to show in desktop viewport
            showReviewsType: REVIEW_TYPE_OF_PROVIDER,
            favListings: [],
        };

        this.showOfProviderReviews = this.showOfProviderReviews.bind(this);
        this.showOfCustomerReviews = this.showOfCustomerReviews.bind(this);
    }

    componentDidMount() {
        // this.props.onGetAllAvailableListing()
    }

    componentDidUpdate(prevProps) {
        const ensuredCurrentUser = ensureCurrentUser(this.props.currentUser);
        const profileUser = ensureUser(this.props.user);
        const prevProfileUser = ensureUser(prevProps.user);
        const isCurrentUser =
            ensuredCurrentUser.id &&
            profileUser.id &&
            ensuredCurrentUser.id.uuid === profileUser.id.uuid;
        const { publicData } = !isCurrentUser
            ? profileUser.attributes.profile
            : this.props.currentUser?.attributes?.profile;
        const prevTemp = !isCurrentUser
            ? prevProfileUser.attributes.profile
            : prevProps.currentUser?.attributes?.profile;
        const prevPublicData = prevTemp.publicData;
        const favCourts = publicData && publicData.favCourts;
        if (
            favCourts &&
            favCourts.length > 0 &&
            favCourts !== prevPublicData?.favCourts
        ) {
            this.props.onGetFavoriteListings(favCourts).then(response => {
                const favListings = response?.data?.data.map(e => {
                    const author = response?.data?.included.find(
                        j =>
                            j.id.uuid === e.relationships?.author?.data?.id.uuid
                    );
                    const images = response?.data?.included.filter(
                        j =>
                            j.id.uuid ===
                            e.relationships?.images?.data[0]?.id.uuid
                    );
                    return {
                        ...e,
                        author,
                        images,
                    };
                });
                this.setState({
                    favListings,
                });
            });
        }
    }

    showOfProviderReviews() {
        this.setState({
            showReviewsType: REVIEW_TYPE_OF_PROVIDER,
        });
    }

    showOfCustomerReviews() {
        this.setState({
            showReviewsType: REVIEW_TYPE_OF_CUSTOMER,
        });
    }

    render() {
        const {
            scrollingDisabled,
            currentUser,
            user,
            userShowError,
            reviews,
            queryReviewsError,
            viewport,
            intl,
            listings,
            isAuthenticated,
            onUpdateProfile,
            history
        } = this.props;

        const ensuredCurrentUser = ensureCurrentUser(currentUser);
        const profileUser = ensureUser(user);
        const isCurrentUser =
            ensuredCurrentUser.id &&
            profileUser.id &&
            ensuredCurrentUser.id.uuid === profileUser.id.uuid;
        const { publicData, bio } = !isCurrentUser
            ? profileUser.attributes.profile
            : currentUser?.attributes?.profile;
        const displayName = profileUser.attributes.profile.displayName;
        const playerType = publicData && publicData.playerType;
        const sportType = publicData && publicData.sportType;
        const favCourts = publicData && publicData.favCourts;
        const city = publicData && publicData.city;
        const state = publicData && publicData.state;
        const country = publicData && publicData.country;
        const hasCityStateCountry = city && state && country;
        const hasBio = !!bio;
        const hasPlayerType = !!playerType;
        const hasSportType = !!sportType;
        const hasFavCourts = !!favCourts && favCourts.length;
        const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
        const editLinkMobile = isCurrentUser ? (
            <NamedLink
                className={css.editLinkMobile}
                name="ProfileSettingsPage">
                <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
            </NamedLink>
        ) : null;
        const editLinkDesktop = isCurrentUser ? (
            <NamedLink
                className={css.editLinkDesktop}
                name="ProfileSettingsPage">
                <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
        ) : null;

        const asideContent = (
            <div className={css.asideContent}>
                <AvatarLarge
                    className={css.avatar}
                    user={user}
                    disableProfileLink
                />
                <h1 className={css.mobileHeading}>
                    {displayName ? (
                        <FormattedMessage
                            id="ProfilePage.mobileHeading"
                            values={{ name: displayName }}
                        />
                    ) : null}
                </h1>
                {editLinkMobile}
                {editLinkDesktop}
            </div>
        );

        const reviewsError = (
            <p className={css.error}>
                <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
            </p>
        );

        const reviewsOfProvider = reviews.filter(
            r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER
        );

        const reviewsOfCustomer = reviews.filter(
            r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER
        );

        const mobileReviews = (
            <div className={css.mobileReviews}>
                <h2 className={css.mobileReviewsTitle}>
                    <FormattedMessage
                        id="ProfilePage.reviewsOfProviderTitle"
                        values={{ count: reviewsOfProvider.length }}
                    />
                </h2>
                {queryReviewsError ? reviewsError : null}
                <Reviews reviews={reviewsOfProvider} />
                <h2 className={css.mobileReviewsTitle}>
                    <FormattedMessage
                        id="ProfilePage.reviewsOfCustomerTitle"
                        values={{ count: reviewsOfCustomer.length }}
                    />
                </h2>
                {queryReviewsError ? reviewsError : null}
                <Reviews reviews={reviewsOfCustomer} />
            </div>
        );

        const desktopReviewTabs = [
            {
                text: (
                    <h3 className={css.desktopReviewsTitle}>
                        <FormattedMessage
                            id="ProfilePage.reviewsOfProviderTitle"
                            values={{ count: reviewsOfProvider.length }}
                        />
                    </h3>
                ),
                selected:
                    this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER,
                onClick: this.showOfProviderReviews,
            },
            {
                text: (
                    <h3 className={css.desktopReviewsTitle}>
                        <FormattedMessage
                            id="ProfilePage.reviewsOfCustomerTitle"
                            values={{ count: reviewsOfCustomer.length }}
                        />
                    </h3>
                ),
                selected:
                    this.state.showReviewsType === REVIEW_TYPE_OF_CUSTOMER,
                onClick: this.showOfCustomerReviews,
            },
        ];

        const desktopReviews = (
            <div className={css.desktopReviews}>
                <h2
                    className={css.contentTitle}
                    style={{ marginBottom: '-15px' }}>
                    <FormattedMessage id="ProfilePage.reviewsHeaderTitle" />
                </h2>
                <ButtonTabNavHorizontal
                    className={css.desktopReviewsTabNav}
                    tabs={desktopReviewTabs}
                />

                {queryReviewsError ? reviewsError : null}

                {this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER ? (
                    <Reviews reviews={reviewsOfProvider} />
                ) : (
                    <Reviews reviews={reviewsOfCustomer} />
                )}
            </div>
        );

        const playerTypeOptions = findOptionsForSelectFilter(
            'playerType',
            this.props.filterConfig
        );
        const courtTypeOptions = findOptionsForSelectFilter(
            'courtType',
            this.props.filterConfig
        );
        const ustaOptions = findOptionsForSelectFilter(
            'usta',
            this.props.filterConfig
        );
        const ptrOptions = findOptionsForSelectFilter(
            'ptr',
            this.props.filterConfig
        );
        const usptaOptions = findOptionsForSelectFilter(
            'uspta',
            this.props.filterConfig
        );
        const panelMediumWidth = 50;
        const panelLargeWidth = 62.5;
        const cardRenderSizes = [
            '(max-width: 767px) 100vw',
            `(max-width: 1023px) ${panelMediumWidth}vw`,
            `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
            `${panelLargeWidth / 3}vw`,
        ].join(', ');

        const addToFav = id => {
            if (!isAuthenticated) {
                const state = {
                    from: `${this.props.location.pathname}${this.props.location.search}${this.props.location.hash}`,
                };
                // signup and return back to listingPage.
                history.push(
                    createResourceLocatorString(
                        'LoginPage',
                        routeConfiguration(),
                        {},
                        {}
                    ),
                    state
                );
            }

            const { publicData } =
                (currentUser &&
                    currentUser.attributes &&
                    currentUser.attributes.profile) ||
                {};
            const { favCourts } = publicData || {};
            let _favCourts = [];

            if (favCourts && favCourts.length) {
                // already have favourite courts
                const isFavCourtExist = favCourts.find(
                    courtId => courtId === id
                );
                _favCourts = isFavCourtExist
                    ? favCourts.filter(courtId => courtId !== id)
                    : [...favCourts, id];
            } else {
                _favCourts = [id];
            }

            const updatedValues = {
                publicData: { favCourts: _favCourts },
            };

            onUpdateProfile(updatedValues);
        };

        function findFilterLabel(filter, key) {
            var item = filter.find(e => e.key == key);
            return item.label;
        }

        const mainContent = (
            <div className={css.contentWrapper}>
                <h1 className={css.desktopHeading}>
                    <FormattedMessage
                        id="ProfilePage.desktopHeading"
                        values={{ name: displayName }}
                    />
                </h1>
                {hasPlayerType ? (
                    <>
                        <h2 className={css.contentTitle}>I am a</h2>
                        <div className={css.playerType}>
                            {playerTypeOptions.length
                                ? playerTypeOptions.map((type, i) => {
                                      return playerType.includes(type.key) ? (
                                          <div
                                              key={i}
                                              className={css.iconWrapper}>
                                              <img
                                                  className={css.icon}
                                                  src={type.icon}
                                              />
                                              <label>{type.label}</label>
                                              {type.key == 'player' &&
                                              publicData.usta ? (
                                                  <label
                                                      style={{
                                                          fontWeight: '400',
                                                      }}>
                                                      {findFilterLabel(
                                                          ustaOptions,
                                                          publicData.usta
                                                      )}
                                                  </label>
                                              ) : null}
                                              {type.key == 'coach' &&
                                              publicData.ptr ? (
                                                  <label
                                                      style={{
                                                          fontWeight: '400',
                                                      }}>
                                                      {findFilterLabel(
                                                          ptrOptions,
                                                          publicData.ptr
                                                      )}{' '}
                                                      (PTR)
                                                  </label>
                                              ) : null}
                                              {type.key == 'coach' &&
                                              publicData.uspta ? (
                                                  <label
                                                      style={{
                                                          fontWeight: '400',
                                                      }}>
                                                      {findFilterLabel(
                                                          usptaOptions,
                                                          publicData.uspta
                                                      )}{' '}
                                                      (USPTA)
                                                  </label>
                                              ) : null}
                                              {type.key == 'coach' &&
                                              publicData.insured ? (
                                                  <label
                                                      style={{
                                                          fontWeight: '400',
                                                      }}>
                                                      Insured
                                                  </label>
                                              ) : null}
                                          </div>
                                      ) : null;
                                  })
                                : null}
                        </div>
                    </>
                ) : null}
                {hasBio ? (
                    <>
                        <h2 className={css.contentTitle}>About</h2>
                        <p className={css.bio}>{bio}</p>
                    </>
                ) : null}
                {hasCityStateCountry ? (
                    <>
                        <h2 className={css.contentTitle}>I'm from</h2>
                        <p className={css.bio}>
                            {city}, {state}, {country}
                        </p>
                    </>
                ) : null}
                {hasSportType ? (
                    <>
                        <h2 className={css.contentTitle}>Plays</h2>
                        <div className={css.sportType}>
                            {courtTypeOptions.length
                                ? courtTypeOptions.map((type, i) => {
                                      return sportType.includes(type.key) ? (
                                          <div
                                              key={i}
                                              className={css.iconWrapper}>
                                              <img
                                                  className={css.icon}
                                                  src={type.icon}
                                              />
                                              <label>{type.label}</label>
                                          </div>
                                      ) : null;
                                  })
                                : null}
                        </div>
                    </>
                ) : null}
                {hasFavCourts ? (
                    <>
                        <h2 className={css.contentTitle}>Favorite Courts</h2>
                        <div className={css.favCourts}>
                            {this.state.favListings.map(l => {
                                return favCourts.includes(l.id.uuid) ? (
                                    <div className={css.listingCardWrapper}>
                                        <ListingCard
                                            className={css.listingCard}
                                            key={l.id.uuid}
                                            listing={l}
                                            renderSizes={cardRenderSizes}
                                            // setActiveListing={setActiveListing}
                                            addToFav={addToFav}
                                            currentUser={currentUser}
                                            hideFav={true}
                                        />
                                    </div>
                                ) : null;
                            })}
                        </div>
                    </>
                ) : null}
                {isMobileLayout ? mobileReviews : desktopReviews}
            </div>
        );

        let content;

        if (userShowError && userShowError.status === 404) {
            return <NotFoundPage />;
        } else if (userShowError) {
            content = (
                <p className={css.error}>
                    <FormattedMessage id="ProfilePage.loadingDataFailed" />
                </p>
            );
        } else {
            content = mainContent;
        }

        const schemaTitle = intl.formatMessage(
            {
                id: 'ProfilePage.schemaTitle',
            },
            {
                name: displayName,
                siteTitle: config.siteTitle,
            }
        );

        return (
            <Page
                scrollingDisabled={scrollingDisabled}
                title={schemaTitle}
                schema={{
                    '@context': 'http://schema.org',
                    '@type': 'ProfilePage',
                    name: schemaTitle,
                }}>
                <LayoutSideNavigation>
                    <LayoutWrapperTopbar>
                        <TopbarContainer currentPage="ProfilePage" />
                    </LayoutWrapperTopbar>
                    <LayoutWrapperSideNav className={css.aside}>
                        {asideContent}
                    </LayoutWrapperSideNav>
                    <LayoutWrapperMain>{content}</LayoutWrapperMain>
                    <LayoutWrapperFooter>
                        <Footer />
                    </LayoutWrapperFooter>
                </LayoutSideNavigation>
            </Page>
        );
    }
}

ProfilePageComponent.defaultProps = {
    currentUser: null,
    user: null,
    userShowError: null,
    reviews: [],
    queryReviewsError: null,
    filterConfig: config.custom.filters,
};

const { bool, arrayOf, number, shape } = PropTypes;

ProfilePageComponent.propTypes = {
    scrollingDisabled: bool.isRequired,
    currentUser: propTypes.currentUser,
    user: propTypes.user,
    userShowError: propTypes.error,
    reviews: arrayOf(propTypes.review),
    queryReviewsError: propTypes.error,

    // form withViewport
    viewport: shape({
        width: number.isRequired,
        height: number.isRequired,
    }).isRequired,

    // from injectIntl
    intl: intlShape.isRequired,
};

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const { updateInProgress } = state.ProfileSettingsPage;
    const {
        userId,
        userShowError,
        reviews,
        queryReviewsError,
    } = state.ProfilePage;
    const { isAuthenticated } = state.Auth;
    const allListings =
        state.marketplaceData.entities &&
        state.marketplaceData.entities.listing;
    let listingIds = [];
    if (allListings && Object.keys(allListings).length) {
        Object.keys(allListings).map(function(key, index) {
            listingIds.push(allListings[key].id);
        });
    }
    const mapListings = getListingsById(state, listingIds);

    const userMatches = getMarketplaceEntities(state, [
        { type: 'user', id: userId },
    ]);
    const user = userMatches.length === 1 ? userMatches[0] : null;
    return {
        scrollingDisabled: isScrollingDisabled(state),
        currentUser,
        user,
        userShowError,
        reviews,
        queryReviewsError,
        listings: mapListings,
        isAuthenticated,
        updateInProgress,
    };
};

const mapDispatchToProps = dispatch => ({
    onGetFavoriteListings: data => dispatch(getFavoriteListings(data)),
    onUpdateProfile: data => dispatch(updateProfile(data)),
});

const ProfilePage = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withViewport,
    injectIntl
)(ProfilePageComponent);

export default ProfilePage;
